import { contextApp } from 'context';
import React, { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

const RoutesPublic = () => {
 const { auth } = contextApp();
 const navigate = useNavigate();

 useEffect(() => {
  console.log(auth, 'aqui se esta redirigiendo');
  if (auth?.token) return navigate('/1/app/calendar');
  return;
 }, []);

 return <Outlet />;
};

export default RoutesPublic;
